import { render, staticRenderFns } from "./ListaMonitoramentoAgricola.vue?vue&type=template&id=0a5087d1&scoped=true&lang=pug"
import script from "./ListaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./ListaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./ListaMonitoramentoAgricola.vue?vue&type=style&index=0&id=0a5087d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5087d1",
  null
  
)

export default component.exports